import React, {FC} from "react";
import {Avatar, Box} from "@material-ui/core";

import RichText from "view/components/RichText";
import {
  IDefaultEmailTemplate,
  IOrganiser,
  IShow,
} from "@evennt-tech/api-v2-core";
import Typography from "@material-ui/core/Typography";
import {usePreviewTranslate} from "view/EmailTemplatePage/PreviewTranslate";
import {blue, grey} from "@material-ui/core/colors";
import useStyles from "./styles";

type Props = {
  show: IShow;
  organiser: IOrganiser;
  emailTemplate: IDefaultEmailTemplate;
};

const templateVariables = {
  showName: /(&lt;|<){1}Show Name(&gt;|>){1}/g,
  organiserName: /(&lt;|<){1}Organiser Name(&gt;|>){1}/g,
};

const ExhibitorInviteEmailBody: FC<Props> = ({
  emailTemplate,
  show,
  organiser,
}) => {
  const classes = useStyles();
  const t = usePreviewTranslate();

  const parseTextVariables = (text?: string) => {
    if (!text) return "";

    return text
      .replace(templateVariables.showName, show.name)
      .replace(
        templateVariables.organiserName,
        organiser?.organiserCompanyToOrganisers?.[0]?.organiserCompany?.name ??
          ""
      );
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box className={classes.logosContainer}>
        <Avatar
          className={classes.logo}
          variant="square"
          src={show.logoFile?.url || ""}
        />
      </Box>
      <Box className={classes.greeting}>
        {parseTextVariables(emailTemplate.greeting)}
      </Box>

      <Box className={classes.emailBody}>
        <RichText
          className={classes.mainText}
          content={parseTextVariables(emailTemplate.mainText)}
        />
        <RichText
          className={classes.secondaryText}
          content={parseTextVariables(emailTemplate.secondaryText)}
        />
      </Box>
      {/*
        Static platform copy, not the organiser's — the same keys the API sends
        to SendGrid for this template, so the preview matches what is delivered.
        The English defaults keep the wording unchanged until the keys land in
        Tolgee.
      */}
      <Box marginY={2}>
        <Typography
          variant="h5"
          style={{textAlign: "center", color: grey[500]}}
        >
          {t(
            "emails.exhibitor$invite_by_organiser.activated_note",
            "Note: If you have already activated your account, you can log in here:"
          )}
          <br />
          <span style={{textDecoration: "underline", color: blue.A400}}>
            https://app.ffair.io
          </span>{" "}
          {t(
            "emails.exhibitor$invite_by_organiser.login_instruction",
            "using the email address and password you set during activation."
          )}
          <br />
          {t(
            "emails.exhibitor$invite_by_organiser.forgot_password_intro",
            "If you have forgotten your password, please click"
          )}{" "}
          <span style={{fontWeight: 500}}>
            {t(
              "emails.exhibitor$invite_by_organiser.forgot_password_action",
              "Forgot password"
            )}
          </span>{" "}
          {t(
            "emails.exhibitor$invite_by_organiser.forgot_password_outro",
            "to reset it."
          )}
          <br />
          {t(
            "emails.exhibitor$invite_by_organiser.reset_only_if_activated",
            "This will only work if your account has already been activated."
          )}
        </Typography>
      </Box>
      <Box className={classes.submitButton}>
        {parseTextVariables(emailTemplate.buttonText)}
      </Box>
    </Box>
  );
};

export default ExhibitorInviteEmailBody;
